import { defineComponent, computed, createBlock, openBlock, unref, normalizeClass, withCtx, createCommentVNode, renderSlot } from "vue";
import IconLoader2 from "../../../_virtual/loader-2.js";
import { cn } from "../../../lib/utils.js";
import { buttonVariants } from "./variants.js";
import { P as Primitive } from "../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Primitive/Primitive.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    class: {},
    buttonType: { default: "primary" },
    size: {},
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    buttonVariant: {},
    danger: { type: Boolean },
    shape: {},
    href: {},
    target: {},
    variant: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(__props) {
    const props = __props, buttonVariantsRef = computed(() => {
      if (props.variant)
        return { variant: props.variant };
      let color = props.buttonType === "primary" ? "primary" : "secondary", buttonVariant = props.buttonVariant;
      return props.danger && (color = "danger", buttonVariant = buttonVariant ?? (props.buttonType === "primary" ? "default" : "outlined")), { color, buttonVariant };
    }), asRef = computed(() => !props.as && props.href ? "a" : props.as ?? "button");
    return (_ctx, _cache) => (openBlock(), createBlock(unref(Primitive), {
      class: normalizeClass(unref(cn)(unref(buttonVariants)({ ...buttonVariantsRef.value, size: props.size, shape: props.shape }), props.class)),
      disabled: _ctx.loading || _ctx.disabled,
      href: props.href,
      target: props.target,
      as: asRef.value,
      "as-child": props.asChild,
      "data-slot": "button"
    }, {
      default: withCtx(() => [
        _ctx.loading ? (openBlock(), createBlock(unref(IconLoader2), {
          key: 0,
          class: "w-4 h-4 mr-2 animate-spin"
        })) : createCommentVNode("", !0),
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "disabled", "href", "target", "as", "as-child"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Button.js.map
